export default "__VITE_ASSET__Do_i74OV__"